module.exports = __webpack_public_path__ + "img/linkedin.03f28bb.svg";